import { EXAMS } from "@tt-app/constants";

const contentGetters = {
  filteredGroupCourses(state: any, getters: any, rootState: any) {
    const {
      content: {
        group: { courses }
      },
      course: {
        group: { selectedCategoryIds, selectedExamIndex, selectedLevelIndexes }
      },
      user: { groups }
    } = rootState;

    if (!groups || !courses) {
      return undefined;
    } else if (groups.length <= 0 || courses.length <= 0) {
      return [];
    }

    const levelIndexArray: any[] = [];
    Object.entries(selectedLevelIndexes).forEach(([key, value]) => {
      if (value === true) levelIndexArray.push(parseInt(key, 10));
    });

    const levelFilters = new Set();
    levelIndexArray.forEach((level: any) => {
      EXAMS[selectedExamIndex].levels[level].cefrjMap.forEach(levelFilters.add, levelFilters);
    });

    const categoryIds = Object.entries(selectedCategoryIds)
      .map(([id, selected]) => {
        if (selected) return id;
      })
      .filter(Boolean);

    if (!courses) {
      return [];
    }

    let filteredCourses: any[] = courses;

    if (levelFilters.size) {
      filteredCourses = filteredCourses.filter((course: any) => {
        return levelFilters.has(course.cefrj);
      });
    }

    if (categoryIds && categoryIds.length) {
      filteredCourses = filteredCourses
        .map((course: any) => {
          const courseCategories = course.categories.map((category: any) => category.uuid);

          const allFiltersMatched = categoryIds.some((id: any) => courseCategories.includes(id));

          if (allFiltersMatched) return course;
        })
        .filter(Boolean);
    }

    return filteredCourses;
  },
  filteredOrganizationCourses(state: any, getters: any, rootState: any) {
    const {
      content: {
        organization: { courses }
      },
      course: {
        explore: { searchString, selectedCategoryIds, selectedExamIndex, selectedLevelIndexes }
      }
    } = rootState;

    const lowerCaseSearchString = searchString.toLowerCase();

    const levelIndexArray: any[] = [];
    Object.entries(selectedLevelIndexes).forEach(([key, value]) => {
      if (value === true) levelIndexArray.push(parseInt(key, 10));
    });

    const levelFilters = new Set();
    levelIndexArray.forEach((level: any) => {
      EXAMS[selectedExamIndex].levels[level].cefrjMap.forEach(levelFilters.add, levelFilters);
    });

    const categoryIds = Object.entries(selectedCategoryIds)
      .map(([id, selected]) => {
        if (selected) return id;
      })
      .filter(Boolean);

    let filteredCourses: any[] = courses;

    if (lowerCaseSearchString.length) {
      filteredCourses = filteredCourses.filter((course: any) => {
        return course.title.toLowerCase().includes(lowerCaseSearchString);
      });
    }

    if (levelFilters.size) {
      filteredCourses = filteredCourses.filter((course: any) => {
        return levelFilters.has(course.cefrj);
      });
    }

    if (categoryIds && categoryIds.length) {
      filteredCourses = filteredCourses
        .map((course: any) => {
          const courseCategories = course.categories.map((category: any) => category.uuid);

          const allFiltersMatched = categoryIds.some((id: any) => courseCategories.includes(id));

          if (allFiltersMatched) return course;
        })
        .filter(Boolean);
    }

    return filteredCourses;
  },
  bookmarkedCourses(state: any) {
    return state.bookmark.courses;
  },
  loadingBookmarkedCourses(state: any) {
    return state.bookmark.loading;
  },
  recommendedCourses(state: any) {
    return state.recommended.courses;
  },
  loadingRecommendedCourses(state: any) {
    return state.recommended.loading;
  }
};

export { contentGetters };
